import api from '~config/api';

const CouponsService = {
  getAvailableCouponsByUserEmail: ({ email }) => api.get(`/v1/coupons/availables_by_email?email=${email}`)
};

export default CouponsService;
